module.exports = __webpack_public_path__ + "img/contactbgimg.0b184352.png";